const endpoint = (base) => `${base.replace(/\/$/, '')}/identity/member-self/payment-drafts`;
async function body(response) {
    const result = (await response.json());
    if (!response.ok)
        throw new Error(result.message ?? 'No se pudo completar la solicitud.');
    return result;
}
export async function getPaymentDraftCatalogs(base, memberId) {
    return body(await fetch(`${endpoint(base)}/catalogs`, {
        credentials: 'include',
        headers: { 'X-Urbanik-Member-Id': encodeURIComponent(memberId ?? '') },
    }));
}
export async function getOwnPaymentDrafts(base) {
    return body(await fetch(endpoint(base), { credentials: 'include' }));
}
export async function submitOwnPaymentDraft(base, input) {
    const response = await fetch(endpoint(base), {
        method: 'POST',
        credentials: 'include',
        body: input.file,
        headers: {
            'Content-Type': input.file.type,
            'X-Urbanik-Payment-Method': encodeURIComponent(input.methodCode),
            'X-Urbanik-Payment-Amount': encodeURIComponent(input.amount),
            'X-Urbanik-Payment-Date': encodeURIComponent(input.transactionDate),
            'X-Urbanik-Origin-Bank': encodeURIComponent(input.originBank),
            'X-Urbanik-Payment-Reference': encodeURIComponent(input.transactionReference),
            'X-Urbanik-Allocation-Scope': encodeURIComponent(input.allocationScope),
            'X-Urbanik-Destination-Account': encodeURIComponent(input.destinationAccount),
            'X-Urbanik-Member-Observation': encodeURIComponent(input.memberObservation),
            'X-Urbanik-File-Name': encodeURIComponent(input.file.name),
            'X-Urbanik-Member-Id': encodeURIComponent(input.memberId ?? ''),
        },
    });
    return body(response);
}
export async function searchPaymentMembers(base, query) {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/payments/member-search`);
    url.searchParams.set('query', query);
    return body(await fetch(url, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
    }));
}
const accountsEndpoint = (base) => `${base.replace(/\/$/, '')}/identity/payments/destination-accounts`;
export async function getPaymentDestinationAccounts(base) {
    return body(await fetch(accountsEndpoint(base), { credentials: 'include' }));
}
export async function createPaymentDestinationAccount(base, input) {
    return body(await fetch(accountsEndpoint(base), {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    }));
}
export async function updatePaymentDestinationAccount(base, id, input) {
    return body(await fetch(`${accountsEndpoint(base)}/${encodeURIComponent(id)}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    }));
}
const manualEndpoint = (base) => `${base.replace(/\/$/, '')}/identity/payments/manual-allocations`;
export async function getManualAllocationPayments(base) {
    return body(await fetch(manualEndpoint(base), { credentials: 'include' }));
}
export async function getManualAllocationDetail(base, id) {
    return body(await fetch(`${manualEndpoint(base)}/${encodeURIComponent(id)}`, { credentials: 'include' }));
}
export async function saveManualAllocations(base, id, allocations) {
    return body(await fetch(`${manualEndpoint(base)}/${encodeURIComponent(id)}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ allocations }),
    }));
}
export const manualAllocationEvidenceUrl = (base, id) => `${manualEndpoint(base)}/${encodeURIComponent(id)}/evidence`;
export async function confirmManualAllocations(base, id, observation = '') {
    return body(await fetch(`${manualEndpoint(base)}/${encodeURIComponent(id)}/confirm`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ observation }),
    }));
}
export const paymentReceiptUrl = (base, id) => `${base.replace(/\/$/, '')}/identity/payments/${encodeURIComponent(id)}/official-receipt`;
export async function emailPaymentReceipt(base, id) {
    return body(await fetch(`${base.replace(/\/$/, '')}/identity/payments/${encodeURIComponent(id)}/email-receipt`, {
        method: 'POST',
        credentials: 'include',
    }));
}
export async function rejectManualPayment(base, id, reason) {
    return body(await fetch(`${manualEndpoint(base)}/${encodeURIComponent(id)}/reject`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason }),
    }));
}
export async function reversePayment(base, id, reason) {
    return body(await fetch(`${base.replace(/\/$/, '')}/identity/payments/${encodeURIComponent(id)}/reverse`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reason }),
    }));
}
export async function getPaymentHistory(base, filters) {
    const url = new URL(`${base.replace(/\/$/, '')}/identity/payments/history`);
    Object.entries(filters).forEach(([k, v]) => {
        if (v !== undefined && v !== '')
            url.searchParams.set(k, String(v));
    });
    return body(await fetch(url, { credentials: 'include' }));
}
export async function getPaymentHistoryDetail(base, id) {
    return body(await fetch(`${base.replace(/\/$/, '')}/identity/payments/history/${encodeURIComponent(id)}`, {
        credentials: 'include',
    }));
}
